import React, { useEffect, useState } from 'react';
import { TestProvider } from './contexts/TestContext';
import StartPage from './components/StartPage';
import QuestionPage from './components/QuestionPage';
// 移除姓名輸入頁面的引入
import LoadingPage from './components/LoadingPage';
import ResultPage from './components/ResultPage';
import MusicPlayer from './components/MusicPlayer';
import Lanterns from './components/Lanterns';
import Footer from './components/Footer';
import Character from './components/Character'; 
import { useTest } from './contexts/TestContext';
import SoundUtils from './utils/SoundUtils';
import './styles/main.css';

// 設備警告組件
const DeviceWarning = ({ onContinue }) => {
  return (
    <div className="device-warning">
      <div className="device-warning-content">
        <p>嘿！此測驗以<b> 行動裝置寬度 </b>瀏覽體驗更佳！<br></br>你可以調整視窗大小到合適的寬度，這個提示會自動消失。或者你也可以不鳥我，選擇...</p>
        <button onClick={onContinue}>直接進入</button>
      </div>
    </div>
  );
};

// 主要內容組件，根據當前階段顯示不同的頁面
const MainContent = () => {
  const { stage } = useTest();
  const [showLanterns, setShowLanterns] = useState(true);
  
  // 監聽階段變化，控制燈籠顯示
  useEffect(() => {
    // 在loading階段和result階段隱藏燈籠
    setShowLanterns(stage !== 'loading' && stage !== 'result');
  }, [stage]);

  return (
    <>
      {showLanterns && <Lanterns />}
      {stage === 'start' && <StartPage />}
      {stage === 'questions' && <QuestionPage />}
      {/* 移除姓名輸入頁面的渲染 */}
      {stage === 'loading' && <LoadingPage />}
      {stage === 'result' && <ResultPage />}
    </>
  );
};

// 主應用組件
function App() {
  // 添加狀態來控制警告顯示
  const [showWarning, setShowWarning] = useState(window.innerWidth > 600);
  
  // 監聽窗口尺寸變化
  useEffect(() => {
    const handleResize = () => {
      setShowWarning(window.innerWidth > 600);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // 初始化音效
  useEffect(() => {
    SoundUtils.init();
  }, []);
  
  // 處理繼續按鈕點擊
  const handleContinue = () => {
    setShowWarning(false);
  };

  return (
    <TestProvider>
      <div className="app-container">
        {showWarning && <DeviceWarning onContinue={handleContinue} />}
        <MainContent />
        <MusicPlayer />
        <Footer />
        <Character /> {/* 添加角色元件 */}
      </div>
    </TestProvider>
  );
}

export default App;